module.exports = __webpack_public_path__ + "static/img/icon_help@2x.4e369113.png";